import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import Buefy from 'buefy'
//import 'buefy/dist/buefy.css'
import axios from 'axios'
import store from './store'

Vue.use(Buefy)

Vue.prototype.$axios = axios
//Vue.prototype.$URL = 'https://jsonplaceholder.typicode.com/'
Vue.prototype.$URL = 'http://tostado.edgarsandoval.mx/api/'
Vue.prototype.$APP_NAME = 'Tostatronic Shop'

Vue.config.productionTip = false

new Vue({
  store,
  router,
  render: function (h) { return h(App) }
}).$mount('#app')
